import { computed, inject, Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Store } from '@ngrx/store';
import * as AppSettingsActions from './app-settings.actions';
import { DEFAULT_EXTRA_CENTS_KEY, MARGIN_THRESHOLD_KEY, POINTS_PER_EUR_KEY } from './app-settings.constants';
import * as AppSettingsSelectors from './app-settings.selectors';

@Injectable({
  providedIn: 'root',
})
export class AppSettingsFacade {
  private store = inject(Store);

  settings$ = this.store.select(AppSettingsSelectors.selectAllSettings);
  loading$ = this.store.select(AppSettingsSelectors.selectAppSettingsLoading);
  error$ = this.store.select(AppSettingsSelectors.selectAppSettingsError);

  settings = toSignal(this.settings$, { initialValue: [] });
  loading = toSignal(this.loading$, { initialValue: false });

  defaultExtraCents = computed(() => {
    const setting = this.settings().find(s => s.key === DEFAULT_EXTRA_CENTS_KEY);
    return setting ? Number(setting.value) : 0;
  });

  marginThresholdPercent = computed(() => {
    const setting = this.settings().find(s => s.key === MARGIN_THRESHOLD_KEY);
    return setting ? Number(setting.value) : 0;
  });

  pointsPerEur = computed(() => {
    const setting = this.settings().find(s => s.key === POINTS_PER_EUR_KEY);
    return setting ? Number(setting.value) : 8;
  });

  loadSettings(): void {
    this.store.dispatch(AppSettingsActions.loadSettings());
  }

  updateSetting(key: string, value: string): void {
    this.store.dispatch(AppSettingsActions.updateSetting({ key, value }));
  }
}
